import { render, staticRenderFns } from "./appConfigForm.vue?vue&type=template&id=dd145efe&scoped=true"
import script from "./appConfigForm.vue?vue&type=script&lang=js"
export * from "./appConfigForm.vue?vue&type=script&lang=js"
import style0 from "./appConfigForm.vue?vue&type=style&index=0&id=dd145efe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd145efe",
  null
  
)

export default component.exports